export default __webpack_public_path__ + "static/media/1466.0e518444.png";